import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD6nYfZLvV3DZtNo-AGN1drZSl2Auu7ukE",
  authDomain: "truckspot-b5f9a.firebaseapp.com",
  projectId: "truckspot-b5f9a",
  storageBucket: "truckspot-b5f9a.firebasestorage.app",
  messagingSenderId: "659701572262",
  appId: "1:659701572262:web:e9206f1e42dde8ea664a67"
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app)

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app)

export default app